import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgUpsColored({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 22c.191-.08 4.767-2.038 6.206-3.206 1.504-1.22 2.294-2.971 2.294-5.062V3.888l-.12-.064c-3.66-1.953-8.196-1.826-8.386-1.82-.176-.006-4.707-.133-8.373 1.817l-.121.064v9.844c0 2.09.795 3.841 2.298 5.062 1.439 1.168 6.013 3.126 6.203 3.206"
        fill="#503629"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.775 18.787c1.469 1.188 6.223 3.21 6.223 3.21l-.003.003s4.76-2.022 6.229-3.211c1.536-1.243 2.276-2.987 2.276-5.005V3.84c-3.755-1.993-8.502-1.836-8.502-1.836S7.252 1.849 3.5 3.843v9.941c0 2.018.74 3.762 2.275 5.003zm.427-.513c-1.325-1.073-2.027-2.626-2.027-4.49V8.058c4.697-4.251 10.632-4.533 15.647-4.073v9.8c0 1.863-.698 3.416-2.026 4.49-1.188.961-4.793 2.56-5.797 2.997-1.003-.437-4.607-2.035-5.797-2.998z"
        fill="#FDBD10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.835 8.5v4.713l.006.175c.027.394.167.86.696.86.177.008.354-.03.514-.112l.117-.07V8.5H9.5v6.409c-.458.343-1.058.547-1.768.585l-.24.006c-1.267-.002-1.933-.727-1.988-2.16l-.004-.2V8.5h1.335zm11.383.418a2.27 2.27 0 00-1.424-.417c-.898.029-1.836.721-1.83 1.894 0 .773.205 1.352 1.325 2.059l.142.091c.496.328.7.571.71.99.01.51-.318.813-.82.81-.436 0-.956-.261-1.305-.592v1.34l.174.103c.41.223.865.343 1.328.349 1.349 0 1.95-1.02 1.98-1.946.025-.849-.195-1.491-1.335-2.205l-.1-.063c-.461-.285-.81-.5-.796-.995.013-.516.416-.699.8-.694.479.004.939.286 1.224.598V8.974l-.073-.056zm-3.566 3.022c0-2.123-.895-3.439-2.523-3.439-.743 0-1.343.178-1.837.518V18.5h1.365l-.002-3.062.15.038c.153.032.309.047.464.044 1.514 0 2.383-1.457 2.383-3.58zm-2.88-2.208c.117-.04.241-.06.366-.059.791 0 1.119.675 1.119 2.304 0 1.59-.375 2.359-1.16 2.359a1.214 1.214 0 01-.443-.088v-4.47l.117-.046z"
        fill="#FDBD10"
      />
    </svg>
  )
}

export default SvgUpsColored
